import React from "react";

function ImageSponsor({sponsor}) {
  const imageName = sponsor.name
                 .toLowerCase()
                 .replace(/ /g, "_")
                 .replace(/[\W]+/g, "")
                 .replace(/__/g, "_");

  return (    
    <img 
      src={process.env.PUBLIC_URL + "/sponsors/" + imageName + ".jpg?v2"} 
      alt={sponsor.name} 
      title={sponsor.name} 
      height="125" 
    />
  );
}

export default ImageSponsor;